import { render, staticRenderFns } from "./itemList.vue?vue&type=template&id=4a043eab&scoped=true"
import script from "./itemList.vue?vue&type=script&lang=js"
export * from "./itemList.vue?vue&type=script&lang=js"
import style0 from "./itemList.vue?vue&type=style&index=0&id=4a043eab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a043eab",
  null
  
)

export default component.exports